module.exports = __webpack_public_path__ + "static/media/icon-piece4-6.b30930b6.png";